import { useMutation } from "@apollo/client";

import { SetUserFinancialProfileMutation, SetUserFinancialProfileMutationVariables } from "@ctypes";
import { SET_FINANCIAL_PROFILE, USER } from "@graphql";

export const useSetUserFinancialProfile = () => {
  return useMutation<SetUserFinancialProfileMutation, SetUserFinancialProfileMutationVariables>(
    SET_FINANCIAL_PROFILE,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
